<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="[getSelectedDEV && 'dev-selected-component']">
    <v-timeline v-bind="schema.attributesTimeline" :class="['i4pro-timeline', schema.attributesCard.dateAlignTop && 'date-align-top']">
      <v-timeline-item
        v-for="(item, indexItem) in items"
        :key="indexItem"
        v-bind="schema.attributesTimelineItem"
        :color="schema.attributesCard.color"
      >
        <span
          :class="[schema.attributesCard.opposite.type, schema.attributesCard.opposite.type == 'date-bg' && schema.attributesCard.opposite.color]"
          slot="opposite"
        >
          <v-icon :class="schema.attributesCard.opposite.color">calendar_today</v-icon>
          <span :class="schema.attributesCard.opposite.type == 'date-icon-bg' && `${schema.attributesCard.opposite.color}--text`">{{
            item.date
          }}</span>
        </span>
        <v-expansion-panels
          v-model="models[`model_${indexItem}`]"
          v-if="schema.attributesCard.cardsGroup.group"
          v-bind="schema.attributesGroup"
          class="column-group"
        >
          <v-expansion-panel v-for="(card, indexCard) in item.children" :key="indexCard">
            <v-expansion-panel-header :class="[schema.attributesCard.cardsGroup.class]">
              <div>
                <span v-if="schema.attributesCard.title.display" v-html="getTitle(card).title"></span>
                <span v-html="getTitle(card).value"></span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <i4proTimelineCard :schema="schema" :card="card" :isGroup="true" :formOptions="formOptions"></i4proTimelineCard>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div v-else>
          <div v-for="(card, indexCard) in item.children" :key="indexCard">
            <i4proTimelineCard :schema="schema" :card="card" :isGroup="false" :formOptions="formOptions"></i4proTimelineCard>
          </div>
        </div>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
import moment from 'moment';
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

export default {
  mixins: [abstractField, devComponentMixin],

  components: {
    i4proTimelineCard: () => import('@/components/timeline/i4pro-timeline-card')
  },

  data() {
    return {
      items: [],
      showCollapse: [],
      model_teste: [0, 1, 2],
      models: {}
    };
  },

  beforeCreate() {},

  mounted() {
    this.createArray();

    this.setPanelExpand();
  },

  watch: {
    schema: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.createArray();
        }
      },
      deep: true
    }
  },

  methods: {
    setPanelExpand() {
      if ('expand' in this.schema.attributesCard.cardsGroup && this.schema.attributesCard.cardsGroup.expand === true) {
        let childrenLength = 0;

        // verifica qual children, tem mais objetos
        this.items.forEach(objItem => {
          if (objItem.children.length > childrenLength) childrenLength = objItem.children.length;
        });

        // aplica o array que expande, para todas as models
        this.items.forEach((objItem, index) => (this.models[`model_${index}`] = [...Array(childrenLength).keys()].map((k, i) => i)));
      }
    },

    getTitle(card) {
      const title = this.schema.attributes.headers.filter(mode => mode.value == 'title')[0];

      if (title) {
        return {
          title: title.text,
          value: card.title
        };
      }
    },

    createArray() {
      let { items } = this.schema.attributes;

      if (items.length) {
        let list = {};
        for (let i = 0; i < items.length; i++) {
          const e = items[i];

          const newItem = e;
          if (!list[e.date]) {
            // ainda não tem nada nesta data, criar um novo
            list[e.date] = { date: moment(e.date).format('DD/MM/YYYY'), children: [newItem] };
          } else {
            // já existe registro para a data, adiciona no array children já existente
            list[e.date].children.push(newItem);
          }
        }

        this.items = Object.values(list);
      }
    }
  }
};
</script>
